import axios from 'axios';

import cfac22 from '../cfac22';

export default function getPowerBI(configId, _uid) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(cfac22('API_HOST_V2') + '/powerBI/embedInfo?configId=' + configId, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        // console.log("RESULTADO API GETPOWERBI ===>: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERRO API POWERBI ===>: ", error);
        return reject(error.response.data);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
